import { useEffect, useRef, useState } from 'react'
import styles from './PopupMobileAppDevelopment.module.scss'

const Popup: React.FunctionComponent = () => {
  const popupRef = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)
  const [isClosed, setIsClosed] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (isClosed || !popupRef.current) return

      const halfWindow = window.scrollY + window.innerHeight * 0.5
      const documentHeight = document.body.offsetHeight * 0.15
      const footer = document.getElementById('contact')
      const footerTop = footer?.getBoundingClientRect().top || Infinity

      if (halfWindow > documentHeight && window.scrollY + window.innerHeight < footerTop + window.scrollY) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [isClosed])

  const handleClose = () => {
    setIsVisible(false)
    setIsClosed(true)
  }

  return (
    <div className={`${styles.popupCTA} ${isVisible ? styles.isShow : ''}`} ref={popupRef}>
      <span className={styles.popupCTA__close} onClick={handleClose} />
      <div className={styles.popupCTA__container}>
        <div className={styles.popupCTA__inner}>
          <p className={styles.popupCTA__text}>
            スマホアプリ開発の”伴走パートナー”として、
            <br />
            課題を捉え、最適な戦略と体制をご提案します。
          </p>
          <p className={styles.popupCTA__btn}>
            <a href="#contact">プロジェクトのご相談はこちら</a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Popup
